import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { openModal } from "risa-oasis-ui_v2";
import CustomTable from "../../../../components/custom-table/custom-table";
import DocViewerModal from "../../../../components/modals/docViewerModal/docViewerModal";
import { useDataAccumulatorForSingleOrder } from "../../../../context/dataAccumulatorForSingleOrder";
import { ModalId } from "../../../../enums/modalId";
import { closeModal } from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import {
  generateJCodeDocsTableData,
  JCodeDocsTableTableColumns,
} from "../../utils/generateTableDataForJcodeDocs";

/**
 * Documents tab for the external single-order page.
 * Reads auth-on-file and general order details from {@link useDataAccumulatorForSingleOrder},
 * builds J-code document rows, and renders them in a {@link CustomTable}.
 */
const JCodeDocuments = () => {
  // const { singleMedicalPaOrder } = useSelector(
  //   (state: RootState) => state.singleMedicalPaOrder,
  // );
  const { authOnFileDetails, generalOrderDetails } =
    useDataAccumulatorForSingleOrder();
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  const { metaData, openedModalId } = useSelector(
    (state: RootState) => state.modal,
  );
  const [tableData, setTableData] = useState<any[]>([]);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (authOnFileDetails) {
      const jCodeDocsTableData = generateJCodeDocsTableData(
        authOnFileDetails?.auth_on_file ?? {},
        generalOrderDetails?.order?.timestamps?.order_created_at ?? "",
        authStatusOptions,
      );

      setTableData(jCodeDocsTableData || []);
    }
  }, [authOnFileDetails, generalOrderDetails, authStatusOptions]);

  useEffect(() => {
    if (openedModalId === ModalId.DOC_VIEWER_MODAL) {
      openModal(ModalId.DOC_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
  }, [openedModalId, metaData]);

  return (
    <div className="jcode-documnets--container">
      <CustomTable
        tableHeaders={JCodeDocsTableTableColumns}
        tableData={tableData}
        tableName="jcode_documents"
        pagesPerView={tableData.length}
        itemsPerPage={20}
        count={tableData.length}
        hideSearchBar={true}
        hidePagination={true}
      />
      {openedModalId === ModalId.DOC_VIEWER_MODAL && (
        <DocViewerModal
          type="clinical_attachment"
          onClose={() => dispatch(closeModal())}
        />
      )}
    </div>
  );
};

export default JCodeDocuments;
